import React, { useEffect, useState } from 'react';
import { ConfigProvider, Spin, Empty, message, Button} from 'antd';
import { useNavigate } from 'react-router-dom';
import PricingService from '../../services/PricingService';
import PurchaseService from '../../services/PurchaseService';

const Pricing = ({setPaymentDone}) => {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState({});
  const [schoolDetails, setSchoolDetails] = useState({});
  console.log("school details in pyament is", schoolDetails)
  const [islogged, setIsLogged] = useState(null);
  console.log("is logged pricing ", islogged)

  useEffect(() => {
    fetchPricing();
    fetchSchoolDetails();
  }, []);

  const fetchPricing = async () => {
    try {
      setLoading({
        list: true
      });
      const response = await PricingService.getPlanList();
      const data = Array.isArray(response) ? response : (response?.data || []);
      setPlans(data);
    } catch (error) {
      console.error("Error fetching pricing plans:", error);
    } finally {
      setLoading();
    }
  };

  const fetchSchoolDetails = async () => {
    const data = JSON.parse(localStorage.getItem("school_details"));
    setSchoolDetails(data);
    if(data && data?.orgId){
      setIsLogged(true);
    } else {
      setIsLogged(false);
    }
  }

  const getPlanMetadata = (planName) => {
    const meta = {
      Normal: { class: "credentialing", features: ["Basic SIS access", "Progress tracking"], popular: false },
      Standard: { class: "wallet", features: ["Learning paths", "10GB Storage"], popular: false },
      Premium: { class: "human-resources", features: ["Virtual classrooms", "Advanced analytics"], popular: true },
      Club: { class: "education", features: ["Branded portals", "AI-driven learning"], popular: false },
      "Elite Club": { class: "marketing", features: ["SSO & Security", "Custom Dev"], popular: false },
      "Super Elite Club": { class: "credentialing", features: ["Predictive AI", "Full Infrastructure"], popular: false },
    };
    return meta[planName] || { class: "education", features: ["Full Access"], popular: false };
  };

  const onSucessPayment = async (planId) => {
   try {

    const userId = schoolDetails?.orgId;
    const response = await PurchaseService.subscribePlan(userId, planId);
    if(response?.status === 200) {
      setPaymentDone(true);
      message.success("Thanks for purchase a plan")
      message.success(response?.data?.message)
    }
   } catch (error) {
    message.error("Error occur during payment");
    console.log("Error occur during saving subscription", error)
   }
  }

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (document.getElementById("razorpay-script")) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.id = "razorpay-script";
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (cost, planId) => {
    const isScriptLoaded = await loadRazorpayScript();
    if(!islogged){
      message.error("Before purchase any plan you have to first login.")
      navigate("/auth/login");
      return;
    }
    if (!isScriptLoaded) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    try {
      setLoading({subscription: true, id: planId})
      const res = await fetch(
        "https://stusphere-stg-api.azurewebsites.net/api/payment/create-order",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ amount: cost }),
        }
      );

      const data = await res.json();
      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency,
        name: "UGLAU App",
        description: "Test Transaction",
        order_id: data.orderId,
        handler: function (response) {
          // alert("Payment successful!");
          console.log("Payment ID:", response.razorpay_payment_id);
          console.log("Order ID:", response.razorpay_order_id);
          console.log("Signature:", response.razorpay_signature);
          onSucessPayment(planId);
        },

        prefill: {
          name: "Test User",
          email: "test@example.com",
          contact: "9999999999",
        },
        theme: { color: "#3399cc" },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setLoading();
    }
  };

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#0984e3", borderRadius: 16 } }}>
      <div className="pricing-container">
        <header className='product-subtitleBg-header pricing-header'>
          <h1 className="pricing-main-title">Stusphere Education Operating System</h1>
          <p className="pricing-sub-title">
            Transparent pricing for the next generation of learning. Plans for every school size.
          </p>
        </header>

        {loading?.list ? (
          <div style={{ textAlign: 'center', padding: '50px' }}><Spin size="large" /></div>
        ) : plans.length > 0 ? (
          <div className="pricing-card-grid">
            {plans.map((plan) => {
              const meta = getPlanMetadata(plan.name);
              return (
                <div
                  key={plan.id}
                  className={`pricing-card ${meta.class} ${meta.popular ? "popular" : ""}`}
                >
                  <div className="overlay"></div>
                  {meta.popular && <div className="badge">Most Popular</div>}
                  
                  <div className="pricing-card-content">
                    <h2 className="pricing-plan-name">{plan.name}</h2>
                    
                    {/* Dynamic Price from API */}
                    <div className="plan-price" style={{ margin: '15px 0' }}>
                        <span style={{ fontSize: '32px', fontWeight: 800 }}>₹
                        {plan.price}</span>
                        <span style={{ color: '#666' }}> / {plan.durationInDays} days</span>
                    </div>

                    <p className="pricing-description">
                        Support up to <strong style={{color: '#0984e3'}}>{plan.maxStudents.toLocaleString()}</strong> students.
                    </p>
                    
                    <ul className="pricing-feature-list">
                      {/* Using static features mapped to plan name */}
                      {meta.features.map((f, i) => (
                        <li key={i} className="pricing-feature-item">
                          <span className="pricing-check">✓</span> {f}
                        </li>
                      ))}
                      <li className="pricing-feature-item">
                        <span className="pricing-check">✓</span> Annual Validity
                      </li>
                    </ul>
                    
                    <Button
                      className="pricing-button"
                      onClick={() => handlePayment(plan?.price, plan?.id)}
                      loading={(loading?.subscription && loading?.id === plan?.id)}
                    >
                      Subscribe now
                    </Button>
                    <p className="pricing-limit-text">Billed per {plan.durationInDays} days</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <Empty description="No pricing plans available" />
        )}

        <section className="pricing-info-section">
          <div className="pricing-info-grid">
            <div className="pricing-info-box">
              <h3>Institutional Enrollment</h3>
              <p>
                Our plans are scaled by student capacity to ensure fair pricing for small
                academies and large university districts alike.
              </p>
            </div>

            <div className="pricing-info-box">
              <h3>Flexible Upgrades</h3>
              <p>
                Exceeded your student limit? Upgrade your plan at any time to accommodate 
                your growing school population without downtime.
              </p>
            </div>
          </div>
        </section>
      </div>
    </ConfigProvider>
  );
};

export default Pricing;